<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    title="编辑用户"
    :visible.sync="dialogFormVisible"
    @closed="closed"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="状态" :label-width="formLabelWidth">
        <el-cascader
          v-model="value"
          :options="options"
          placeholder="请选择活动区域"
          @change="changeStatus"
          :show-all-levels="false"
        >
        </el-cascader>
      </el-form-item>

      <!-- 已签约(租) -->
      <div v-if="childStatus === '7-1'">
        <el-form-item
          label="租赁起止时间"
          :label-width="formLabelWidth"
          prop="timeLimit"
        >
          <!-- <el-input v-model="editForm.timeLimit"  autocomplete="off"></el-input> -->
          <el-date-picker
            v-model="dateTime"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            prop="dateTime"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="租赁天数"
          :label-width="formLabelWidth"
          prop="rentCycle"
        >
          <el-input v-model="editForm.rentCycle" autocomplete="off"></el-input>
        </el-form-item>
      </div>

      <!-- 已签约(购) / 已签约(租)  -->
      <div v-if="childStatus === '7-1' || childStatus === '7-2'">
        <el-form-item
          label="单价"
          :label-width="formLabelWidth"
          prop="unitPrice"
        >
          <el-input
            v-model="editForm.unitPrice"
            autocomplete="off"
            placeholder="例如: 100/平方/月(租) 8888元/平米(购)"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="总价"
          :label-width="formLabelWidth"
          prop="totalPrice"
        >
          <el-input v-model="editForm.totalPrice" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="合同备注"
          :label-width="formLabelWidth"
          prop="explain"
        >
          <el-input
            v-model="editForm.explain"
            type="textarea"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="签约时间"
          :label-width="formLabelWidth"
          prop="signedTime"
        >
          <!-- <el-input v-model="editForm.signedTime"  autocomplete="off"></el-input> -->
          <el-date-picker
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="变更状态描述"
          :label-width="formLabelWidth"
          prop="reviewOpinion"
        >
          <el-input
            v-model="editForm.reviewOpinion"
            type="textarea"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item
        v-if="editForm.status !== 4"
        label="备注"
        :label-width="formLabelWidth"
        prop="opinion"
      >
        <el-input
          type="textarea"
          v-model="editForm.opinion"
          autocomplete="off"
          placeholder="请说明变更原因"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { changeStatusApi } from '@/api/introduce';
// import { getToken } from '@/utils/token.js'
export default {
  name: 'ChangeStatus',
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      dateTime: '',
      date: '',
      value: '',
      // 编辑表单
      editForm: {
        appRecordId: '',
        opinion: '',
        timeLimit: '',
        unitPrice: '',
        totalPrice: '',
        rentCycle: '',
        explain: '',
        signedTime: '',
        reviewOpinion: '',
      },
      // 表单的验证规则
      editRules: {
        remark: [
          { required: true, message: '备注不能为空！', trigger: 'blur' },
        ],
        rentCycle: [
          { required: true, message: '租赁天数不能为空！', trigger: 'blur' },
        ],
        unitPrice: [
          { required: true, message: '单价不能为空！', trigger: 'blur' },
        ],
        totalPrice: [
          { required: true, message: '总价不能为空！', trigger: 'blur' },
        ],
        explain: [
          { required: true, message: '合同备注不能为空！', trigger: 'blur' },
        ],
        signedTime: [
          { required: true, message: '签约时间不能为空！', trigger: 'blur' },
        ],
        timeLimit: [
          {
            required: true,
            message: '租赁起止时间不能为空！',
            trigger: 'blur',
          },
        ],
        reviewOpinion: [
          {
            required: true,
            message: '变更状态描述不能为空！',
            trigger: 'blur',
          },
        ],
      },
      // ['全部', '未到访', '已到访', '已分配','已过期','人工分配','已失效', '已签约', '复核可结佣', '已结佣']
      options: [
        { label: '未到访', value: '未到访' },
        { label: '已到访', value: '已到访' },
        { label: '已分配', value: '已分配' },
        { label: '已过期', value: '已过期' },
        { label: '人工分配', value: '人工分配' },
        { label: '已失效', value: '已失效' },
        {
          label: '已签约',
          value: '已签约',
          children: [
            { label: '已签约(租)', value: '已签约(租)' },
            { label: '已签约(购)', value: '已签约(购)' },
          ],
        },
        { label: '复核可结佣', value: '复核可结佣' },
        { label: '已结佣', value: '已结佣' },
      ],
      childStatus: '',
    };
  },
  computed: {
    ...mapGetters(['pickerOptions']),
  },
  watch: {
    // 将标准时间转换成 yyyy-mm-dd
    dateTime(val) {
      let timeList = val.map((item) => {
        return this.$moment(item).format('YYYY-MM-DD HH:mm:ss');
      });
      return (this.editForm.timeLimit = timeList.join(','));
    },
    date(val) {
      return (this.editForm.signedTime = this.$moment(val).format(
        'YYYY-MM-DD HH:mm:ss'
      ));
    },
  },
  methods: {
    changeStatus(val) {
      try {
        let status = val[val.length - 1];
        this.options.forEach((item, index) => {
          // 获取选择的下标， 由于数组0-5， status参数是1-6，所以要加一
          if (item.children) {
            item.children.forEach((key, i) => {
              if (item.value == status || key.value == status) {
                // 已签约有两种状态， 7-1是租， 7-2是购，此参数用来做标记不传后端
                this.editForm.status = index + 1;
                this.childStatus = index + 1 + '-' + (i + 1);
              }
            });
          }
          if (item.value == status) {
            this.editForm.status = index + 1;
            this.childStatus = index + 1;
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 提交按钮
    submitEdit() {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let data =
        'appRecordId=' +
        this.editForm.appRecordId +
        '&opinion=' +
        this.editForm.opinion +
        '&areaId=' +
        areaId;
      let data2 = {
        appRecordId: this.editForm.appRecordId,
        unitPrice: this.editForm.unitPrice,
        totalPrice: Number(this.editForm.totalPrice),
        explain: this.editForm.explain,
        signedTime: this.editForm.signedTime,
        reviewOpinion: this.editForm.reviewOpinion,
        areaId,
      };
      let data3 = {
        appRecordId: this.editForm.appRecordId,
        unitPrice: this.editForm.unitPrice,
        totalPrice: Number(this.editForm.totalPrice),
        explain: this.editForm.explain,
        signedTime: this.editForm.signedTime,
        reviewOpinion: this.editForm.reviewOpinion,
        timeLimit: this.editForm.timeLimit,
        rentCycle: Number(this.editForm.rentCycle),
        areaId,
      };
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return;
          switch (this.childStatus) {
            case 2:
              // 已到访
              await changeStatusApi('toVisited', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 3:
              // 已分配
              await changeStatusApi('toAssigned', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 4:
              // 已过期
              await changeStatusApi('toExpired', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 5:
              // 人工分配
              await changeStatusApi('toManualAssignment', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 6:
              // 已失效
              await changeStatusApi('toInvalidate', data).then((res) => {
                this.res1 = res;
              });
              break;
            case '7-1':
              // 已签约（租）
              await changeStatusApi('toSignedForRent', data3, false).then(
                (res) => {
                  this.res1 = res;
                }
              );
              break;
            case '7-2':
              // 已签约（购）
              await changeStatusApi('toSignedForSale', data2, false).then(
                (res) => {
                  this.res1 = res;
                }
              );
              break;
            case 8:
              // 复核可结佣
              await changeStatusApi('toServable', data).then((res) => {
                this.res1 = res;
              });
              break;
            case 9:
              // 已结佣
              await changeStatusApi('toPayment', data).then((res) => {
                this.res1 = res;
              });
              break;
            default:
              this.$message.error(
                '不支持状态往回修改，如需修改请联系您的管理员'
              );
          }
          if (this.res1.code === 200) {
            this.$message.success('变更成功！');
            this.dialogFormVisible = false;
            this.$refs.editForm.resetFields();
            this.$emit('fetchData');
          } else {
            // this.$message.error(this.res1 && this.res1.message);
          }
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 关闭时的回调
    closed() {
      this.editForm.status = '';
      this.childStatus = '';
      this.value = null;
    },
  },
  created() {},
};
</script>

<style lang="less" scoped></style>
